var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaleBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3002 7.64687C14.3002 9.46941 12.8227 10.9469 11.0002 10.9469C9.17765 10.9469 7.70019 9.46941 7.70019 7.64687M4.33353 19.1969H17.6669C18.8451 19.1969 19.8002 18.2595 19.8002 17.1032L18.4335 4.89684C18.4335 3.74053 17.4784 2.80316 16.3002 2.80316H5.43353C4.25532 2.80316 3.3002 3.74053 3.3002 4.89684L2.2002 17.1032C2.2002 18.2595 3.15532 19.1969 4.33353 19.1969Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleBlack);
export default __webpack_public_path__ + "static/media/sale_Black.208cd0187eca7bde40477ada12ec2703.svg";
export { ForwardRef as ReactComponent };